import { Notify } from 'quasar'

export function showError(message: string) {
  Notify.create({
    color: 'negative',
    icon: 'error',
    position: 'top-right',
    classes: 'text-white',
    actions: [{ icon: 'close', color: 'white', round: true }],
    message,
  })
}

export function showSuccess(message: string, icon = 'done') {
  Notify.create({
    color: 'positive',
    position: 'top-right',
    classes: 'text-black',
    actions: [{ icon: 'close', color: 'black', round: true }],
    message,
    icon,
  })
}
